export default function ContactSection() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value.trim();
    if (honeypot) {
      const statusEl = document.getElementById('contact-status');
      if (statusEl) statusEl.textContent = '感谢你的反馈，我们会尽快处理！';
      form.reset();
      return;
    }

    const formData = new FormData(form);
    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key !== 'phone_alt') params.append(key, value as string);
    });

    try {
      const response = await fetch('https://readdy.ai/api/form/d9mnnou8mbnljin59psg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      const statusEl = document.getElementById('contact-status');
      if (response.ok && parsed?.code === 'OK') {
        if (statusEl) statusEl.textContent = '感谢你的反馈，我们会尽快处理！';
        form.reset();
      } else {
        const errMsg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后再试';
        if (statusEl) statusEl.textContent = errMsg;
      }
    } catch {
      const statusEl = document.getElementById('contact-status');
      if (statusEl) statusEl.textContent = '网络错误，请稍后再试';
    }
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              联系我们
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              有任何建议或问题，欢迎给我们留言
            </p>
          </div>

          <div className="max-w-[560px] mx-auto">
            <form
              data-readdy-form=""
              id="contact-form"
              onSubmit={handleSubmit}
              className="bg-background-50 rounded-lg border border-background-200/60 p-6 md:p-8 space-y-4"
            >
              <div>
                <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1">
                  你的昵称
                </label>
                <input
                  id="contact-name"
                  name="name"
                  type="text"
                  required
                  className="w-full px-4 py-2.5 text-sm border border-background-300/60 rounded-lg bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                  placeholder="请输入昵称"
                />
              </div>

              <div>
                <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1">
                  邮箱地址
                </label>
                <input
                  id="contact-email"
                  name="email"
                  type="email"
                  required
                  className="w-full px-4 py-2.5 text-sm border border-background-300/60 rounded-lg bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                  placeholder="请输入邮箱"
                />
              </div>

              <div>
                <label htmlFor="contact-msg" className="block text-sm font-medium text-foreground-700 mb-1">
                  留言内容
                </label>
                <textarea
                  id="contact-msg"
                  name="message"
                  required
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-2.5 text-sm border border-background-300/60 rounded-lg bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                  placeholder="请输入留言内容（不超过500字）"
                />
              </div>

              <input
                name="phone_alt"
                type="text"
                className="honeypot-field"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />

              <button
                type="submit"
                className="w-full px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                提交留言
              </button>

              <p id="contact-status" className="text-sm text-center text-foreground-600 min-h-[20px]" />
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}